import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";
import viewMoreIcon from "../../assets/Icons/view_more_icon.svg";
import Button from "../customButton/Button";

const DetailModal = ({
  open,
  onClose,
  text,
  icon,
  headingText,
  headingTextClass,
  textClass,
  okButtonClass,
  buttonSize,
}) => {
  const handleSubmit = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      transitionDuration={500}
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: "30%",
          position: "relative",
          //   top: "-40vh",
          animation: "slide-in 0.5s forwards",
          borderRadius: "16px",
          minWidth: "25%",
        },
      }}
    >
      <DialogContent className="flex flex-col items-center p-6 overflow-y-auto custom-scrollbar">
        <img
          src={LeftCircle}
          alt="leftImg"
          className="absolute left-0 bottom-0 w-[110px] h-[105px]"
        />
        <img
          src={RightCircle}
          alt="leftImg"
          className="absolute right-0 top-0 w-[110px] h-[105px]"
        />
        <div className="flex justify-between w-full">
          <div className="flex items-center gap-2">
            <img src={icon || viewMoreIcon} alt="icon" className="w-8 h-8" />
            <h2
              className={`text-lg font-medium text-primary ${headingTextClass}`}
            >
              {headingText}
            </h2>
          </div>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className="w-full mt-6">
          <p
            className={`text-sm font-normal text-[#000] break-words ${textClass}`}
          >
            {text}
          </p>
        </div>
      </DialogContent>
      <DialogActions
        className={`flex justify-center space-x-4 py-4 m-auto mb-6 ${okButtonClass}`}
      >
        <Button
          label="OK"
          onClick={handleSubmit}
          size={buttonSize ? buttonSize : "medium"}
          className="z-10 border !border-[#FF702B] text-primary !bg-[#FFFFFF] !h-[33px]"
        />
      </DialogActions>
    </Dialog>
  );
};

export default DetailModal;
